<template>
  <v-container mt-3 justify-center>
    <p class="display-3 text-center my-8">Projetos Cadastrados</p>
    <v-card max-width="720" class="mx-auto">
      <v-card-text>
        <v-data-table
          :headers="getHeaders()"
          :items="projects"
          :search="search"
          no-results-text="Sem resultados para essa busca"
          sort-by="name"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  label="Filtrar dados"
                  prepend-icon="mdi-magnify"
                  hide-details
                  color="secondary"
                  v-model="search"
                ></v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <div v-if="checkIsAdmin()">
                <v-btn color="secondary" class="mb-2 mr-2" @click="exportJson">
                  <v-icon left style="color: #ffffff !important"> mdi-download </v-icon>
                  Json
                </v-btn>
              </div>
              <template>
                <v-tooltip bottom v-if="!registrationOpen">
                  <template #activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn
                        color="secondary"
                        class="mb-2"
                        :disabled="true"
                      >
                        <v-icon left style="color: #ffffff !important">
                          mdi-plus
                        </v-icon>
                        Cadastrar
                      </v-btn>
                    </span>
                  </template>
                  <span>Fora do prazo para inscrições</span>
                </v-tooltip>

                <v-btn
                  v-else
                  color="secondary"
                  class="mb-2"
                  @click="createItem"
                >
                  <v-icon left style="color: #ffffff !important">
                    mdi-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </template>
            </v-toolbar>
          </template>

          <template v-slot:item.totalPrice="{ item }">
            R$ {{ item.totalPrice | currencyMask }}
          </template>

          <template v-slot:item.validated="{ item }">
            {{ getValidatedStatus(item) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  style="color: green !important"
                  v-on="on"
                  v-if="checkIfIsManagerOrAdmin()"
                  small
                  class="ml-2"
                  :class="{ 'is-disabled': item.validated === 1 }"
                  @click="approveProject(item)"
                  :disabled="item.validated === 1"
                  >mdi-checkbox-marked-circle</v-icon
                >
              </template>
              Aprovar Projeto
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  style="color: red !important"
                  v-on="on"
                  v-if="checkIfIsManagerOrAdmin()"
                  small
                  class="ml-2 mr-4"
                  @click="rejectProject(item)"
                  :class="{ 'is-disabled': item.validated === 0 }"
                  aria-label="Reprovar Projeto"
                >
                  mdi-cancel
                </v-icon>
              </template>
              Reprovar Projeto
            </v-tooltip>
            <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:no-data>
            <no-results />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog persistent v-model="dialogDelete" max-width="320">
      <v-card>
        <v-card-title class="title"
          >Deseja apagar esse<br />
          projeto?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="secondary" text @click="deleteItemConfirm">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Project from '@/models/Project';
import Price from '@/models/Price';
import File from '@/models/File';
import NoResults from '@/components/NoResults';
import api from '@/services/api';
import getErrorMessage from '@/utils/getErrorMessage';
import { mapActions } from 'vuex';

export default {
  name: 'projects',

  components: { NoResults },

  data: () => ({
    dialogDelete: false,
    search: '',
    departmentType: '',
    registrationOpen: false,
    projects: [],
    editedIndex: -1,
    editedItem: {
      name: '',
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: '',
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
  }),

  watch: {
    dialogDelete(val) {
      return val || this.closeDelete();
    },
  },

  methods: {
    checkIsAdmin() {
      if (this.$store.state.isAdmin === true) {
        return true;
      }
      return false;
    },
    checkIfIsManagerOrAdmin() {
      if (this.$store.state.isManager === true || this.$store.state.isAdmin === true) {
        return true;
      }
      return false;
    },
    async fetchRegistrationStatus() {
      try {
        const response = await api.get('/projects/registrationStatus');
        this.registrationOpen = response.data.open;
      } catch (error) {
        console.error('Erro ao verificar o status do período de inscrição:', error);
        this.registrationOpen = false;
      }
    },

    async listProjects() {
      let projects = [];

      try {
        this.$store.dispatch('loadingDataTable', true);

        api.defaults.headers.Authorization = `Bearer ${this.$store.state.token}`;

        let projectsResponse = '';

        if (this.$store.state.isAdmin === true) {
          projectsResponse = await api.get('/admin/projects');
        }

        if (this.$store.state.isAdmin === false && this.$store.state.isManager === false) {
          projectsResponse = await api.get('/user/projects');
        }

        if (this.$store.state.isAdmin === false && this.$store.state.isManager === true) {
          projectsResponse = await api.get('/manager/projects');
        }

        if (projectsResponse) {
          projects = projectsResponse.data.projects;
        }

        if (!projects || !projects.length) {
          this.projects = [];
          return;
        }

        this.projects = projects;
        // this.projects = fakeProjects;
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loadingDataTable', false);
      }
    },
    createItem() {
      this.$store.dispatch('editProject', new Project());
      this.$store.dispatch('saveOriginalProject', new Project());
      this.$store.dispatch('saveOriginalPrices', [new Price()]);
      this.$store.dispatch('saveOriginalFiles', [new File()]);
      this.goToRegister();
    },

    exportJson() {
      const data = JSON.stringify(this.projects);
      const blob = new Blob([data], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'projetos.json');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async editItem(item) {
      this.editedIndex = this.projects.indexOf(item);
      this.editedItem = { ...item };
      const originalItem = { ...item };
      const originalPrices = [...item.prices];
      const originalFiles = [...item.files];
      await this.$store.dispatch('editProject', this.editedItem);
      this.$store.dispatch('saveOriginalProject', originalItem);
      this.$store.dispatch('saveOriginalPrices', originalPrices);
      this.$store.dispatch('saveOriginalFiles', originalFiles);
      await this.goToRegister();
    },

    deleteItem(item) {
      this.editedIndex = this.projects.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        this.$store.dispatch('loading', true);

        await api.delete(`/projects/${this.editedItem.id}`);

        this.projects.splice(this.editedIndex, 1);

        this.$store.dispatch('toggleToastAlert', {
          type: 'success',
          message: 'Projeto apagado com sucesso',
        });
      } catch (error) {
        const message = getErrorMessage(error);

        this.$store.dispatch('toggleToastAlert', { message });
      } finally {
        this.$store.dispatch('loading', false);
        this.closeDelete();
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    goToRegister() {
      this.$router.push('/register');
    },
    getHeaders() {
      return [
        {
          text: this.departmentType,
          align: 'start',
          value: 'secretary',
        },
        { text: 'Nome', value: 'name' },
        { text: 'Despesa', align: 'center', value: 'totalPrice' },
        { text: 'Status', align: 'center', class: 'validation-status', value: 'validated' },
        { text: 'Ações', align: 'end', value: 'actions', sortable: false, width: '150px' },
      ];
    },
    async mapRoles() {
      this.$store.dispatch('isAdmin', false);
      this.$store.state.realTokenDecoded.profiles.map(perfil => {
        if (
          perfil.per_dcperfil === 'Administrador' &&
          perfil.sis_sgsistema === 'OrcamentoParticipativo'
        ) {
          this.$store.dispatch('isAdmin', true);
          return true;
        }
        if (
          perfil.per_dcperfil === 'Gestor Secretaria' &&
          perfil.sis_sgsistema === 'OrcamentoParticipativo'
        ) {
          this.$store.dispatch('isManager', true);
          return true;
        }
        if (
          perfil.per_dcperfil !== 'Administrador' &&
          perfil.per_dcperfil === 'Gestor Secretaria' &&
          perfil.sis_sgsistema === 'OrcamentoParticipativo'
        ) {
          this.$store.dispatch('isManager', false);
          this.$store.dispatch('isAdmin', false);
          return true;
        }
        return false;
      });
    },
    ...mapActions(['editProject']),

    approveProject(item) {
      const updatedItem = { ...item };
      updatedItem.validated = 1;

      api
        .put(`/manager/projects/${updatedItem.id}`, updatedItem)
        .then(() => {
          this.editProject(updatedItem);
          this.listProjects();
          this.$store.dispatch('toggleToastAlert', {
            type: 'success',
            message: 'Projeto aprovado com sucesso!',
          });
        })
        .catch(error => {
          const message = getErrorMessage(error);
          this.$store.dispatch('toggleToastAlert', { message });
        });
    },

    rejectProject(item) {
      const updatedItem = { ...item };
      updatedItem.validated = 0;

      api
        .put(`/manager/projects/${updatedItem.id}`, updatedItem)
        .then(() => {
          this.editProject(updatedItem);
          this.listProjects();
          this.$store.dispatch('toggleToastAlert', {
            type: 'success',
            message: 'Projeto marcado como reprovado!',
          });
        })
        .catch(error => {
          const message = getErrorMessage(error);
          this.$store.dispatch('toggleToastAlert', { message });
        });
    },
    getValidatedStatus(item) {
      switch (item.validated) {
        case 0:
          return 'Reprovado';
        case 1:
          return 'Aprovado';
        default:
          return 'Pendente';
      }
    },
  },

  async created() {
    this.departmentType = 'Secretaria';
    await this.$store.dispatch('decodeTokenAction', this.$store.state.token);
    await this.mapRoles();
    this.fetchRegistrationStatus();
    this.listProjects();
  },
};
</script>

<style scoped>
.v-toolbar__title {
  overflow: unset;
}
.is-disabled {
  color: gray !important;
  pointer-events: none;
  opacity: 0.3;
}
</style>
